module.exports = __webpack_public_path__ + "static/media/SKHU_slogen_en.4684a6f3.png";